import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: #c40023 !important;
  text-align: center;

  img[alt='footerbar'] {
    width: 100%;
  }

  .column {
    margin: auto;

    &.is-12 {
      padding: 45px 0 !important;
    }

    &.social {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: wrap;

      .icons {
        margin-left: 20px;
        display: flex;
        justify-items: center;
        align-items: center;
      }
    }

    .menu-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      text-align: left;
      flex-flow: wrap;
      margin: 0;

      li {
        margin-top: 0;

        a {
          color: white;

          &:hover {
            background-color: transparent;
            color: #008ab5;
          }

          &:focus,
          &:focus-within {
            background-color: transparent;
            border: none;
            outline: none;
          }
        }
      }
    }

    .store-links {
      color: white;
      display: flex;
      align-items: center;
      flex-flow: wrap;

      span {
        font-size: 1rem;
        font-weight: 700;
        margin-right: 21px;
        bottom: 0px;
      }

      .logos {
        display: flex;
        flex-wrap: wrap;

        a {
          margin-left: -0.5rem;
        }
      }
    }
  }

  span {
    color: white;
    font-size: 0.8rem;
    bottom: 9px;
    position: relative;
  }

  @media (max-width: 768px) {
    .footbar {
      display: none;
    }

    .column {
      &.social {
        height: 125px;
        display: grid !important;

        img {
          margin: auto;
        }

        .icons {
          margin: 0;
        }
      }

      .menu-list {
        display: grid !important;
        text-align: center;
      }
    }
  }
  @media (max-width: 550px) {
    .column {
      display: grid !important;

      .store-links {
        span {
          margin-right: 0;
        }
      }

      .navbar-item {
        font-weight: 300;
      }
    }
  }
`;

interface CopyRightProps {
  bg: string;
}

export const CopyRight = styled.div<CopyRightProps>`
  font-size: 1rem !important;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: #c40023;
  padding-bottom: 32px;
`;
